module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-table"
  }, [(_vm.table) ? _c('div', {
    ref: "holder",
    staticClass: "holder"
  }, [_c('div', {
    staticClass: "header-scroller"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      transform: ("translate(" + (-_vm.scrollLeft) + "px, 0px)")
    })
  }, [_c('div', {
    ref: "firstHeadRow",
    staticClass: "header-row"
  }, _vm._l((_vm.table.columnNames), function(columnName, colId) {
    return _c('div', {
      staticClass: "cell header-cell",
      class: [{
        'non-numeric': _vm.table.columnTypes[colId] != 'number',
        'sort-desc': _vm.sortColumn == columnName && !_vm.sortAsc,
        'sort-asc': _vm.sortColumn == columnName && _vm.sortAsc
      }],
      style: ({
        width: colId == 0 ? _vm.visibleFirstColumnWidth + 'px' : ''
      }),
      on: {
        "click": function($event) {
          _vm.toggleSort(columnName)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.table.displayColumnNames[colId]) + "\n          ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "header-row"
  }, [_c('div', {
    staticClass: "cell non-numeric"
  }, [_vm._v("\n            Summary:\n          ")]), _vm._l((_vm.table.columnNames.slice(1)), function(columnName, colId) {
    return _c('div', {
      staticClass: "cell",
      class: [{
          'non-numeric': _vm.table.columnTypes[colId + 1] != 'number'
        },
        _vm.generateClass(_vm.table.columnNames[colId + 1])
      ],
      style: ({
        width: colId == 0 ? _vm.visibleFirstColumnWidth + 'px' : ''
      })
    }, [_vm._v("\n            " + _vm._s(_vm.cellText(_vm.table.summary[colId + 1])) + "\n          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    ref: "scroller",
    staticClass: "body-holder",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    style: ({
      height: _vm.topMargin + 'px'
    })
  }), _vm._v(" "), _vm._l((_vm.renderedRows), function(row, rowId) {
    return _c('div', {
      key: rowId + _vm.renderedRowsRange.begin,
      staticClass: "row"
    }, _vm._l((row), function(cell, colId) {
      return _c('div', {
        staticClass: "cell",
        class: [{
            'non-numeric': _vm.table.columnTypes[colId] != 'number'
          },
          _vm.generateClass(_vm.table.columnNames[colId])
        ],
        style: ({
          width: colId == 0 ? _vm.visibleFirstColumnWidth + 'px' : ''
        }),
        on: {
          "mouseover": _vm.handleMouseOver,
          "mouseout": _vm.handleMouseOut
        }
      }, [_c('span', {
        staticClass: "expandable"
      }, [(colId == 0) ? _c('button', {
        staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent copy-words",
        on: {
          "click": function($event) {
            _vm.copyText(_vm.cellText(cell))
          }
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("file_copy")])]) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.cellText(cell)) + "\n            ")])])
    }))
  }), _vm._v(" "), (_vm.endInfo && _vm.bottomMargin == 0) ? _c('div', {
    staticClass: "endInfo",
    class: _vm.endInfo.type
  }, [_c('div', {
    staticClass: "endInfoText"
  }, [_vm._v("\n            " + _vm._s(_vm.endInfo.text) + "\n          ")]), _vm._v(" "), (_vm.endInfo.type == 'download') ? _c('div', [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    on: {
      "click": function($event) {
        _vm.$emit('saveCSV')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("archive")]), _vm._v(" " + _vm._s(_vm.i18n().saveCSV) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    on: {
      "click": function($event) {
        _vm.$emit('saveTSV')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("archive")]), _vm._v(" " + _vm._s(_vm.i18n().saveTSV) + "\n            ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    style: ({
      height: _vm.bottomMargin + 'px'
    })
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.extender) ? _c('div', {
    staticClass: "extender",
    class: [{
      'non-numeric': _vm.extender.nonNumeric
    }],
    style: ({
      left: _vm.extender.x + 'px',
      top: _vm.extender.y + 'px',
      'min-width': _vm.extender.w + 'px',
      'padding-left': _vm.extender.paddingLeft
    })
  }, [_vm._v(_vm._s(_vm.extender.text))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78ee6d04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/BigTable2.vue
// module id = 459
// module chunks = 0